import { QRFC } from "./QRFC";

export class QAPIKeyGenerateRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "api/generateApiKey";
  }

  SetParams(org, userid, sourceId, description, chartId) {
    this.AddParameter("org", org);
    this.AddParameter("user", userid);
    this.AddParameter("sourceId", sourceId);
    this.AddParameter("description", description);
    this.AddParameter("chartId", chartId);
  }
  DoSessionEnded() {
    var response = JSON.parse(this.fRequest.responseText);

    const errorResponse = JSON.stringify({
      success: false,
      error: true,
      message: response.message,
      apiKey: null
    });

    // Resolve the promise with the error response instead of rejecting
    this.fResolve(errorResponse);
  }
}

export class QAPIKeyRetrieveRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "api/getApiKey";
  }

  SetParams(orgName, username, sourceId, chartId) {
    this.AddParameter("org", orgName);
    this.AddParameter("user", username);
    this.AddParameter("sourceId", sourceId);
    this.AddParameter("chartId", chartId);
  }

  DoSessionEnded() {
    var response = JSON.parse(this.fRequest.responseText);

    // Handle the failed transaction gracefully
    const errorResponse = {
      success: false,
      message: response.message,
      error: true
    };

    // If you have a promise to resolve, resolve it with error response
    this.fResolve(errorResponse);
  }
}
